import { IconProps } from './types';

const CaseRecommendationCallingIcon = (props: IconProps) => {
  const { width = 40, height = 40 } = props;
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox={`0 0 ${width} ${height}`}
      fill="none"
      {...props}
    >
      <path
        d="M19.9985 37.7782C29.8169 37.7782 37.7763 29.8188 37.7763 20.0004C37.7763 10.182 29.8169 2.22266 19.9985 2.22266C10.1801 2.22266 2.2207 10.182 2.2207 20.0004C2.2207 29.8188 10.1801 37.7782 19.9985 37.7782Z"
        fill="#C6DFFF"
      />
      <mask
        id="mask0_14175_65123"
        style={{ maskType: 'alpha' }}
        maskUnits="userSpaceOnUse"
        x="2"
        y="2"
        width="36"
        height="36"
      >
        <path
          d="M19.9975 37.7782C29.8159 37.7782 37.7753 29.8188 37.7753 20.0004C37.7753 10.182 29.8159 2.22266 19.9975 2.22266C10.1791 2.22266 2.21973 10.182 2.21973 20.0004C2.21973 29.8188 10.1791 37.7782 19.9975 37.7782Z"
          fill="white"
        />
      </mask>
      <g mask="url(#mask0_14175_65123)">
        <path
          d="M7.07031 19.1119C7.07031 12.0342 12.8588 6.29688 19.9997 6.29688C27.1407 6.29688 32.9292 12.0342 32.9292 19.1119"
          stroke="white"
          strokeWidth="0.888889"
          strokeMiterlimit="10"
          strokeLinecap="round"
        />
        <path
          d="M10.8992 20.2448L8.21507 19.8205C7.97341 19.782 7.80253 19.5665 7.8241 19.3252C7.88193 18.6888 7.96392 18.0147 8.07784 17.3064C8.19176 16.6024 8.32467 15.9395 8.46967 15.3193C8.5249 15.0841 8.75534 14.9309 8.99699 14.9686C9.89198 15.1097 10.7861 15.2517 11.6811 15.3929L10.9 20.244H10.8992V20.2448Z"
          fill="#3879D5"
        />
        <path
          d="M29.0963 20.2448L31.7804 19.8205C32.022 19.782 32.1929 19.5665 32.1705 19.3252C32.1126 18.6888 32.0307 18.0147 31.9167 17.3064C31.8028 16.6024 31.6699 15.9395 31.5249 15.3193C31.4697 15.0841 31.2392 14.9309 30.9976 14.9686C30.1026 15.1097 29.2085 15.2517 28.3135 15.3929L29.0945 20.244H29.0954L29.0963 20.2448Z"
          fill="#3879D5"
        />
        <path
          d="M31.0933 30.148C31.0933 30.148 32.7004 31.3952 32.9593 32.3806C32.9791 32.4568 32.9748 32.5372 32.9489 32.6099C32.8842 32.7895 32.7754 33.2095 32.9118 33.7099C33.0628 34.2685 33.6247 34.6783 34.0718 34.6321C34.9245 34.5431 36.0542 32.9905 35.6537 30.6672C35.2533 28.3439 33.44 25.0676 30.9863 23.166L31.0933 30.1471V30.148Z"
          fill="#3879D5"
        />
        <path
          d="M9.00838 23.168C6.55471 25.0696 4.74143 28.3458 4.34098 30.6692C3.94052 32.9925 5.07112 34.5459 5.92296 34.634C6.37002 34.6802 6.93187 34.2705 7.0829 33.7119C7.2184 33.2106 7.10966 32.7915 7.04579 32.6118C7.0199 32.5383 7.01472 32.4587 7.03544 32.3826C7.29435 31.3963 8.90136 30.1499 8.90136 30.1499L9.00838 23.1688V23.168Z"
          fill="#3879D5"
        />
        <path
          d="M26.8715 37.976C22.2904 38.698 17.7101 38.698 13.129 37.976C10.1938 37.3986 8.69725 35.0444 8.52033 32.6108C8.17769 26.9975 8.67827 21.2696 9.8106 15.4416C10.1075 13.9823 11.2433 12.5836 12.9262 12.2962C17.6428 11.5315 22.3577 11.5315 27.0743 12.2962C28.7754 12.5571 29.8939 13.9823 30.1899 15.4416C31.3223 21.2687 31.822 26.9966 31.4802 32.6108C31.3033 35.0444 29.7299 37.479 26.8715 37.976Z"
          fill="#71AFFF"
        />
        <path
          d="M21.4956 24.0315L20.176 25.236L21.563 31.1675C21.5889 31.2787 21.5578 31.395 21.4793 31.4788L20.2546 32.7953C20.1173 32.9442 19.88 32.9442 19.7419 32.7953L18.5164 31.4788C18.4387 31.395 18.4068 31.2778 18.4327 31.1675L19.8196 25.236L18.5 24.0315L19.9974 22.9785L21.4939 24.0315H21.4948H21.4956Z"
          fill="white"
        />
        <path
          d="M27.5384 22.671C24.3969 23.6488 21.3115 24.1013 20.325 24.2296C20.1084 24.2578 19.89 24.2578 19.6734 24.2296C18.6861 24.1013 15.6015 23.6496 12.4591 22.671C11.5382 22.3845 10.9609 21.482 11.08 20.5342C11.2344 19.3084 11.4519 17.6711 11.6237 16.707C11.8507 15.4889 12.6464 14.3512 14.1576 14.0749C18.05 13.4308 21.9484 13.4308 25.8391 14.0749C27.3468 14.3332 28.146 15.4898 28.373 16.707C28.543 17.6702 28.7614 19.3075 28.9167 20.5342C29.0358 21.482 28.4576 22.3845 27.5376 22.671H27.5393H27.5384Z"
          fill="#3879D5"
        />
        <path
          d="M16.7894 19.3223C16.1784 19.4061 15.569 19.4061 14.958 19.3223C14.6672 19.2787 14.3711 18.9853 14.3271 18.697C14.2425 18.0922 14.2425 17.4883 14.3271 16.8835C14.3711 16.5961 14.668 16.3027 14.958 16.2582C15.569 16.1744 16.1784 16.1744 16.7894 16.2582C17.0803 16.3018 17.3763 16.5952 17.4203 16.8835C17.5049 17.4883 17.5049 18.0922 17.4203 18.697C17.3763 18.9844 17.0794 19.2778 16.7894 19.3223Z"
          fill="#71AFFF"
        />
        <path
          d="M16.7034 18.8906C16.1511 18.9838 15.5987 18.9838 15.0481 18.8906C14.9195 18.8675 14.7892 18.7391 14.7659 18.6117C14.6718 18.0651 14.6718 17.5185 14.7659 16.9718C14.7892 16.8444 14.9186 16.7152 15.0481 16.693C15.6004 16.5997 16.1528 16.5997 16.7034 16.693C16.832 16.7161 16.9623 16.8444 16.9856 16.9718C17.0797 17.5185 17.0797 18.0659 16.9856 18.6117C16.9623 18.7391 16.8329 18.8683 16.7034 18.8906Z"
          fill="white"
        />
        <path
          d="M25.0414 19.3223C24.4303 19.4061 23.821 19.4061 23.21 19.3223C22.9191 19.2787 22.6231 18.9853 22.5791 18.697C22.4945 18.0922 22.4945 17.4883 22.5791 16.8835C22.6231 16.5961 22.92 16.3027 23.21 16.2582C23.821 16.1744 24.4303 16.1744 25.0414 16.2582C25.3322 16.3018 25.6282 16.5952 25.6723 16.8835C25.7568 17.4883 25.7568 18.0922 25.6723 18.697C25.6282 18.9844 25.3313 19.2778 25.0414 19.3223Z"
          fill="#71AFFF"
        />
        <path
          d="M24.9534 18.8906C24.4011 18.9838 23.8487 18.9838 23.2981 18.8906C23.1695 18.8675 23.0392 18.7391 23.0159 18.6117C22.9218 18.0651 22.9218 17.5185 23.0159 16.9718C23.0392 16.8444 23.1686 16.7152 23.2981 16.693C23.8504 16.5997 24.4028 16.5997 24.9534 16.693C25.082 16.7161 25.2123 16.8444 25.2356 16.9718C25.3297 17.5185 25.3297 18.0659 25.2356 18.6117C25.2123 18.7391 25.0829 18.8683 24.9534 18.8906Z"
          fill="white"
        />
        <path
          d="M21.3449 20.2441C21.0972 20.7317 20.588 21.0671 19.9976 21.0671C19.4082 21.0671 18.8981 20.7317 18.6504 20.2441"
          stroke="white"
          strokeWidth="0.444444"
          strokeMiterlimit="10"
          strokeLinecap="round"
        />
        <path
          d="M7.22622 19.248C7.22622 19.248 6.95608 22.0453 8.26361 23.6612C9.44514 25.1214 11.8004 25.851 14.2575 26.3429"
          stroke="white"
          strokeWidth="0.888889"
          strokeMiterlimit="10"
          strokeLinecap="round"
        />
        <path
          d="M8.67286 17.2434C8.84029 16.2041 9.03362 15.2161 9.24161 14.2811C9.28218 14.1006 9.16135 13.9227 8.97665 13.8936C8.48126 13.8149 7.985 13.737 7.48961 13.6592C7.14784 13.6053 6.94675 13.8782 6.74393 14.1545C5.86189 15.3589 5.42087 17.6292 5.83168 19.8191C5.89468 20.1553 6.04227 20.4658 6.38404 20.5197L7.89093 20.7575C8.0739 20.7866 8.24392 20.6574 8.26377 20.4752C8.33886 19.7849 8.51924 18.1929 8.67286 17.2434Z"
          fill="#71AFFF"
        />
        <path
          d="M31.3247 17.2434C31.1572 16.2041 30.9639 15.2161 30.7559 14.2811C30.7153 14.1006 30.8362 13.9227 31.0209 13.8936C31.5162 13.8149 32.0125 13.737 32.5079 13.6592C32.8497 13.6053 33.0508 13.8782 33.2536 14.1545C34.1356 15.3589 34.5766 17.6292 34.1658 19.8191C34.1028 20.1553 33.9552 20.4658 33.6135 20.5197L32.1066 20.7575C31.9236 20.7866 31.7536 20.6574 31.7337 20.4752C31.6587 19.7849 31.4783 18.1929 31.3247 17.2434Z"
          fill="#71AFFF"
        />
        <path
          d="M15.8442 25.7272L14.5617 25.4794C14.0789 25.3862 13.6112 25.6985 13.5171 26.177C13.423 26.6556 13.7381 27.1191 14.2209 27.2124L15.5034 27.4602C15.9863 27.5535 16.4539 27.2412 16.5481 26.7626C16.6422 26.2841 16.3271 25.8205 15.8442 25.7272Z"
          fill="#71AFFF"
        />
        <path
          d="M15.8442 25.7272L14.5617 25.4794C14.0789 25.3862 13.6112 25.6985 13.5171 26.177C13.423 26.6556 13.7381 27.1191 14.2209 27.2124L15.5034 27.4602C15.9863 27.5535 16.4539 27.2412 16.5481 26.7626C16.6422 26.2841 16.3271 25.8205 15.8442 25.7272Z"
          fill="#3879D5"
        />
      </g>
    </svg>
  );
};

export default CaseRecommendationCallingIcon;
